import React, { useEffect, useState, useMemo } from "react";
//import Pagination from "react-bootstrap/Pagination";
import { Pagination } from "react-bootstrap-v5";

const previouNextDisableStyle = {
    marginTop: '6px',
    marginLeft: '10px',
    marginRight: '10px',
    pointerEevents: 'none',
    cursor: 'not-allowed'
}

const firstLastDisableStyle = {
    marginTop: '6px',
    pointerEevents: 'none',
    cursor: 'not-pointer'
}

const prevNextEnableStyle = { marginTop: '6px', marginLeft: '10px', marginRight: '10px', cursor: 'pointer' }
const firstLastStyle = { marginTop: '6px', cursor: 'pointer' }

const PaginationComponent = ({
    total,
    itemsPerPage,
    currentPage,
    onPageChange
}) => {
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        if (total > 0 && itemsPerPage > 0)
            setTotalPages(Math.ceil(total / itemsPerPage));
    }, [total, itemsPerPage]);

    const paginationItems = useMemo(() => {
        const pages = [];
        var startPage, endPage;
        console.log(totalPages);

        if (totalPages <= 5) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 3) {   
                startPage = 1;                
                endPage = 5;            
            } else if (currentPage + 2 >= totalPages) {
                startPage = totalPages - 4;
                endPage = totalPages;
            } else {
                startPage = currentPage - 1;
                endPage = currentPage + 3;
            }

        }

        var startIndex = ((currentPage - 1) * itemsPerPage)==0 ? 1 : (currentPage - 1) * itemsPerPage;
        var endIndex = Math.min(startIndex + itemsPerPage - 1, total - 1);

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <Pagination.Item
                    key={i}
                    active={i == currentPage}
                    onClick={() => onPageChange(i)}
                >
                    {i}
                </Pagination.Item>
            );
        }

     /*
     commented on 3rd may for pagination modification
     for (let i = 1; i <= totalPages; i++) {
            pages.push(
                <Pagination.Item
                    key={i}
                    active={i === currentPage}
                    onClick={() => onPageChange(i)}
                >
                    {i}
                </Pagination.Item>
            );
        }
*/
        return pages;
    }, [totalPages, currentPage]);

    if (totalPages === 0) return null;

    return (



        <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-end">
                <Pagination>
                {currentPage <= 1 ?
                    <a style={firstLastDisableStyle} onClick={() => onPageChange(1)}>{'«'}</a> :
                    <a style={firstLastStyle} onClick={() => onPageChange(1)}>{'«'}</a>
                }
                    

                    {/* <Pagination.Prev
                        onClick={() => onPageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    /> */}
                    {currentPage === 1 ? <a style={previouNextDisableStyle}
                        >{'Prev'}</a> : <a style={prevNextEnableStyle} onClick={() => onPageChange(currentPage - parseInt(1))}
                        >{'Prev'}</a>}


                    {paginationItems}

                    {/* <Pagination.Next
                        onClick={() => onPageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    /> */}


                    {currentPage >= totalPages ? <a style={previouNextDisableStyle}>{'Next'}</a> : <a style={prevNextEnableStyle} onClick={() => onPageChange(parseInt(currentPage) + parseInt(1))}
                    >{'Next'}</a>}

{currentPage >= totalPages ?
                         <a style={firstLastDisableStyle} onClick={() => onPageChange(totalPages)}>{'»'}</a> :
                        <a style={firstLastStyle} onClick={() => onPageChange(totalPages)}>{'»'}</a>
                    }

                   

                </Pagination>


            </ul>
        </nav>

    );
};

export default PaginationComponent;